import { UrlSegmentDelimiter } from './app-style.constants';
import { TimeBlockContentType } from '../../features/calendar/components/time-block/types/time-block-types';

export const TimeBlocksSlug = 'timeblocks';
export const ClientsSlug = 'clients';
export const ProjectsSlug = 'projects';
export const ProjectExpensesSlug = 'project-expenses';
export const StatusSlug = 'status';
export const TasksSlug = 'tasks';
export const UsersSlug = 'users';
export const InvitationSlug = 'invites';
export const ColorsSlug = 'colors';
export const AbsenceReasonsSlug = 'absence-reasons';
export const HolidayTemplatesSlug = 'holiday-templates';
export const TimerSlug = 'timer';
export const ReportsSlug = 'reports';
export const TimetableSlug = 'timetable';
export const GeneratedPdfSlug = 'pdf-generator';
export const FilesSlug = 'files';
export const InvoiceDocumentsSlug = 'invoice-documents';
export const TagSlug = 'tags';
export const InvoiceDocumentOverviewSlug = 'invoice-document-overview';
export const TodoPlannerSlug = 'todo-planner';

// Auth
export const LoginUserSlug = `accounts${UrlSegmentDelimiter}login`;
export const LoggedInUserSlug = `accounts${UrlSegmentDelimiter}current`;
export const RegisterUserSlug = `accounts${UrlSegmentDelimiter}register`;
export const LogoutUserSlug = `accounts${UrlSegmentDelimiter}logout`;
export const CSRFSlug = 'csrf';

// Timeblock Segments
export const TimeBlockBulkDelete = 'bulk-delete';

// Timeblock Querystring Params
export const TimeBlockQueryStrings = new Map<TimeBlockContentType, string>([
  [TimeBlockContentType.Project, 'timeblock_project_type'],
  [TimeBlockContentType.Absence, 'timeblock_absence_type'],
  [TimeBlockContentType.Appointment, 'timeblock_appointment_type'],
]);
